<template>
  <v-container>
    <div class="elevation-2 px-5 mt-3">
      <SimplePageHeader title="Email Review Queue" class="px-4 pr-5 mb-5" />
      <v-row class="px-5 pb-2" align="center">
        <v-col cols="12" sm="4" class="pb-8">
          <v-select
            v-model="filterReviewStatusId"
            :items="reviewStatusOptions"
            item-text="name"
            item-value="id"
            label="Review Status"
            outlined
            dense
            hide-details
            @change="loadSends"
          />
        </v-col>
      </v-row>
    </div>
    <v-container fluid class="px-0 pt-2 mt-4">
      <v-layout column>
        <v-data-table
          dense
          :headers="headers"
          :items="workflowEmailSendList"
          class="elevation-2"
        >
          <template v-slot:item.reviewStatusName="{ item }">
            <v-chip
              x-small
              label
              :color="reviewStatusAttrs(item.reviewStatusId).color"
              :dark="reviewStatusAttrs(item.reviewStatusId).dark"
            >{{ item.reviewStatusName }}</v-chip>
          </template>
          <template v-slot:item.createdAt="{ item }">
            {{ item.createdAt | formatDate }}
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn class="mx-1 my-1" color="primary" outlined small @click="openDetail(item)">
              <v-icon small>visibility</v-icon>
            </v-btn>
            <template v-if="item.reviewStatusId === workflowEmailReviewStatus.PendingInternalReview">
              <v-btn class="mx-1 my-1" color="green" outlined small @click="openApproveConfirmation(item)">
                <v-icon small>check_circle</v-icon>
              </v-btn>
              <v-btn class="mx-1 my-1" color="red" outlined small @click="openRejectDialog(item)">
                <v-icon small>cancel</v-icon>
              </v-btn>
            </template>
          </template>
        </v-data-table>
      </v-layout>
    </v-container>

    <WorkflowEmailSendDetailDialog
      v-if="showDetailDialog"
      :sendId="selectedSend.id"
      @close="showDetailDialog = false"
    />

    <RejectWorkflowEmailSendDialog
      v-if="showRejectDialog"
      @close="showRejectDialog = false"
      @reject="handleReject"
    />

    <ConfirmationModal
      title="Approve & Send"
      :contentText="selectedSend ? `Approve and send &quot;${selectedSend.snapshotSubject}&quot; to ${selectedSend.snapshotExternalRecipients}?` : ''"
      :showModal="showApproveConfirmation"
      toolbarColor="success"
      okText="Approve & Send"
      @ok-click="handleApproveConfirmed"
      @cancel-click="showApproveConfirmation = false; selectedSend = null"
    />

    <BottomSpacer />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import { SimplePageHeader } from '@/components/pageComponents'
import { BottomSpacer } from '@/components/buttons'
import { ConfirmationModal } from '@/components/dialogs'
import WorkflowEmailSendDetailDialog from './WorkflowEmailSendDetailDialog'
import RejectWorkflowEmailSendDialog from './RejectWorkflowEmailSendDialog'
import workflowEmailReviewStatusMixin from './workflowEmailReviewStatusMixin'
import { workflowEmailReviewStatus, WORKFLOW_EMAIL_REVIEW_STATUS_OPTIONS } from '@/lib/constants/workflowEmailStatuses'

export default {
  mixins: [workflowEmailReviewStatusMixin],
  components: {
    SimplePageHeader,
    BottomSpacer,
    ConfirmationModal,
    WorkflowEmailSendDetailDialog,
    RejectWorkflowEmailSendDialog
  },
  data () {
    return {
      workflowEmailReviewStatus,
      reviewStatusOptions: WORKFLOW_EMAIL_REVIEW_STATUS_OPTIONS,
      filterReviewStatusId: workflowEmailReviewStatus.PendingInternalReview,
      selectedSend: null,
      showDetailDialog: false,
      showRejectDialog: false,
      showApproveConfirmation: false,
      headers: [
        { text: 'Template', value: 'workflowEmailTemplateName', sortable: false },
        { text: 'Task', value: 'workflowTaskTitle', sortable: false },
        { text: 'Candidate', value: 'candidateName', sortable: false },
        { text: 'Client', value: 'clientName', sortable: false },
        { text: 'Created', value: 'createdAt', sortable: false, width: '12%' },
        { text: 'Status', value: 'reviewStatusName', align: 'center', sortable: false, width: '15%' },
        { text: 'Actions', value: 'action', align: 'center', sortable: false, width: '15%' }
      ]
    }
  },
  computed: {
    ...mapFields('workflowEmailSends', ['workflowEmailSendList'])
  },
  methods: {
    ...mapActions('workflowEmailSends', ['getWorkflowEmailSends', 'approveWorkflowEmailSend', 'rejectWorkflowEmailSend']),
    loadSends () {
      this.getWorkflowEmailSends({ reviewStatusId: this.filterReviewStatusId })
    },
    openDetail (send) {
      this.selectedSend = send
      this.showDetailDialog = true
    },
    openApproveConfirmation (send) {
      this.selectedSend = send
      this.showApproveConfirmation = true
    },
    handleApproveConfirmed () {
      this.showApproveConfirmation = false
      this.approveWorkflowEmailSend({ id: this.selectedSend.id })
        .then(() => this.loadSends())
        .finally(() => { this.selectedSend = null })
    },
    openRejectDialog (send) {
      this.selectedSend = send
      this.showRejectDialog = true
    },
    handleReject (rejectionReason) {
      this.showRejectDialog = false
      this.rejectWorkflowEmailSend({ id: this.selectedSend.id, rejectionReason })
        .then(() => this.loadSends())
        .finally(() => { this.selectedSend = null })
    }
  },
  created () {
    this.loadSends()
  }
}
</script>
